import { Link } from "react-router-dom";
import Hero from "./components/Hero";
import SectionHeading from "@/components/base/SectionHeading";
import EpisodeCard from "@/components/feature/EpisodeCard";
import CharacterCard from "@/components/feature/CharacterCard";
import NewsCard from "@/components/feature/NewsCard";
import { episodes } from "@/mocks/episodes";
import { characters } from "@/mocks/characters";
import { news } from "@/mocks/news";

const featuredEpisodeIds = ["e1", "e4", "e6", "e12", "e16", "e18"];
const featuredCharacterIds = ["c1", "c2", "c3", "c4"];

export default function Home() {
  const featuredEpisodes = episodes.filter((e) => featuredEpisodeIds.includes(e.id));
  const featuredCharacters = characters.filter((c) => featuredCharacterIds.includes(c.id));
  const latestNews = [...news].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 3);

  const stats = [
    { value: "3", label: "季完整剧情" },
    { value: `${episodes.length}`, label: "集剧情详解" },
    { value: `${characters.length}`, label: "位核心角色" },
    { value: `${news.length}`, label: "篇影视资讯" },
  ];

  return (
    <div>
      <Hero />

      {/* 内容数据概览 */}
      <section className="bg-primary-950 border-t border-primary-800/60">
        <div className="px-4 md:px-8 py-8">
          <div className="max-w-content mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <div className="font-heading text-3xl md:text-4xl font-bold text-accent-400">
                  {s.value}
                </div>
                <div className="mt-1.5 text-xs md:text-sm text-background-200/70">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 剧集剧情精选 */}
      <section className="px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-content mx-auto">
          <SectionHeading
            eyebrow="EPISODES"
            title="剧集剧情精选"
            description="从走进姜家到恩怨落幕，精选每一季的关键剧情，带你快速抓住故事脉络。"
            linkText="查看全部剧情"
            linkTo="/category/episodes"
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {featuredEpisodes.map((episode) => (
              <EpisodeCard key={episode.id} episode={episode} />
            ))}
          </div>
        </div>
      </section>

      {/* 角色分析入口 */}
      <section className="px-4 md:px-8 py-14 md:py-20 bg-background-100">
        <div className="max-w-content mx-auto">
          <SectionHeading
            eyebrow="CHARACTERS"
            title="角色分析专题"
            description="每个人都带着自己的立场走进姜家。读懂他们，才算真正读懂这部剧。"
            linkText="进入角色专题"
            linkTo="/category/characters"
          />
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {featuredCharacters.map((character) => (
              <CharacterCard key={character.id} character={character} />
            ))}
          </div>
        </div>
      </section>

      {/* 影视资讯推荐 */}
      <section className="px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-content mx-auto">
          <SectionHeading
            eyebrow="NEWS"
            title="影视资讯推荐"
            description="剧集回顾、演员专访、幕后花絮，最新动态一网打尽。"
            linkText="浏览全部资讯"
            linkTo="/category/news"
          />
          <div className="flex flex-col gap-4">
            {latestNews.map((article) => (
              <NewsCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      {/* 站点简介 */}
      <section className="px-4 md:px-8 pb-16 md:pb-24">
        <div className="max-w-content mx-auto rounded-lg bg-primary-900 px-6 md:px-12 py-10 md:py-14">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <span className="text-xs tracking-[0.2em] text-accent-400 font-medium">ABOUT US</span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-background-50">
                一个为剧迷而做的内容站
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-200/80 leading-relaxed">
                我们围绕《继母的诱惑》持续整理剧情、角色与资讯，力求让每一次阅读都能帮你更接近故事的内核。本站内容均为演示数据，不涉及播放、下载与付费功能。
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-primary-950 cursor-pointer transition-colors hover:bg-accent-400 whitespace-nowrap"
              >
                了解本站
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/category/episodes"
                className="inline-flex items-center gap-2 rounded-md border border-background-100/30 px-6 py-3 text-sm text-background-50 cursor-pointer transition-colors hover:border-accent-300 hover:text-accent-200 whitespace-nowrap"
              >
                开始探索剧情
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}